import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Slide,
} from "@mui/material";
import { MoreVert, Delete, Close, ErrorOutline } from "@mui/icons-material";
import { deleteMessage } from "../../services/Chat";

// For dialog transition
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteMessage = ({ deletemsgId, setMessages, setRecentChats }) => {
  const [anchorActionEl, setAnchorActionEl] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);

  // open message menu
  const handleClickOpenAction = (event) => {
    setAnchorActionEl(event.currentTarget);
  };

  // close message menu
  const handleCloseAction = () => {
    setAnchorActionEl(null);
  };

  const open = Boolean(anchorActionEl);

  // open delete confirmation modal
  const openDeleteModal = () => {
    setOpenDelete(true);
    handleCloseAction(); // Close menu when modal opens
  };

  // confirm delete
  const confirmDelete = () => {
    deleteMessage(deletemsgId)
      .then((response) => {
        console.log("Message deleted:", response);
        setMessages((prev) => prev.filter((m) => m.id !== deletemsgId));
        setRecentChats((prev) =>  prev.map((chat) => {
          if (chat.last_message && chat.last_message.id === deletemsgId) {
            return { ...chat, last_message: null };
          }
          return chat;
        }));
        setOpenDelete(false);
      })
      .catch((error) => {
        console.error("Failed to delete message:", error);
      });
  };

  // close delete modal
  const handleDeleteClose = () => {
    setOpenDelete(false);
  };

  return (
    <>
      {/* Action menu trigger */}
      <IconButton
        size="small"
        onClick={(e) => handleClickOpenAction(e)}
      >
        <MoreVert fontSize="small" />
      </IconButton>

      {/* Action Menu */}
      <Menu
        anchorEl={anchorActionEl}
        id="message-menu"
        open={open}
        onClose={handleCloseAction}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={openDeleteModal} dense>
          <ListItemIcon>
            <Delete fontSize="small" />
          </ListItemIcon>
          Delete
        </MenuItem>
      </Menu>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDelete}
        TransitionComponent={Transition}
        maxWidth="xs"
        fullWidth
        onClose={handleDeleteClose}
        PaperProps={{
          sx: {
            p: 1,
          },
        }}
      >
        <IconButton
          sx={{ position: "absolute", top: 10, right: 10 }}
          onClick={handleDeleteClose}
        >
          <Close />
        </IconButton>

        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            fontWeight: 600,
          }}
        >
          <ErrorOutline color="error" />
          Delete Message
        </DialogTitle>

        <DialogContent>
          <DialogContentText sx={{ fontSize: 15, color: "text.secondary" }}>
            This action cannot be undone. Are you sure you want to permanently
            delete this message?
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={handleDeleteClose}
            variant="outlined"
            color="inherit"
            size="small"
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            disableElevation
            size="small"
            onClick={confirmDelete}
            sx={{ textTransform: "none" }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteMessage;
